import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { validTenantGuard } from '@core/multi-tenancy/guards/valid-tenant.guard';
import { MessageService } from 'primeng/api';
import { EntryPointManagerService } from '@shared/auth/entry-point-manager.service';

const routes: Routes = [
    {
        path: '',
        redirectTo: (): string => {
            const entryPointManager = inject(EntryPointManagerService);
            return entryPointManager.selectEntryPoint();
        },
        pathMatch: 'full',
    },
    {
        path: 'account',
        canActivate: [validTenantGuard],
        loadChildren: () => import('account/account.module').then((m) => m.AccountModule), // Lazy load account module
        data: { preload: true },
    },
    {
        path: 'app',
        canActivate: [validTenantGuard],
        loadChildren: () => import('app/app.module').then((m) => m.AppModule), // Lazy load account module
        data: { preload: true },
    },
    {
        path: 'fallback',
        loadChildren: () => import('@fallback/fallback.routes').then((m) => m.FALLBACK_ROUTES), // Lazy load fallback route
        providers: [MessageService],
        data: { preload: true },
    },
    {
        path: '**',
        redirectTo: 'fallback',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            bindToComponentInputs: true, // Enables route params to be accessed via input properties in components
        }),
    ],
    exports: [RouterModule],
    providers: [],
})
export class RootRoutingModule {}
